import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/:salesInvoiceId/installments/settle`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const settleInstallments = {
  post: apiPathFunc(pathBase),
};
